import React, { ReactNode } from "react";

export const PlanBoxBody = ({ children }: { children: ReactNode }) => {
  return (
    <div
      css={{
        padding: "16px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 16,
      }}
    >
      {children}
    </div>
  );
};
